export default __webpack_public_path__ + "static/media/icon-extras.d0eac3b9.svg";